<template>
    <v-form ref="form" v-model="valid" :disabled="disabled">
        <!-- TODO [P4] workaround -->
        <v-text-field v-show="false" />
        <div class="d-flex align-center">
            <span class="text-h6 text-capitalize">
                {{ `${$t(`transfers.${pointType === 'departure' ? 'from' : 'to'}`)}: ` }}
            </span>
            <div class="d-flex align-center">
                <v-btn icon="mdi-map-marker" variant="text" color="primary" @click="mapModal = true" />
                <span class="text-subtitle-2">
                    {{
                        `${transferPoint && transferPoint.name} ${point.cityName ? ', ' + point.cityName : ''} ${
                            point.countryName ? ', ' + point.countryName : ''
                        }`
                    }}
                </span>
            </div>
        </div>
        <client-only>
            <v-dialog
                v-if="transferPoint && transferPoint.latitude && transferPoint.longitude"
                v-model="mapModal"
                :max-width="500"
            >
                <map-location
                    v-if="mapModal"
                    :latitude="transferPoint.latitude"
                    :longitude="transferPoint.longitude"
                    :height="`500px`"
                />
            </v-dialog>
        </client-only>
    </v-form>
</template>

<script lang="ts">
    import {Component, mixins, Prop, VModel} from 'vue-facing-decorator'
    import TimeField from '@/components/snippets/forms/TimeField.vue'
    import CityAutocomplete from '@/components/search/forms/CityAutocomplete.vue'
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'
    import {TransferFormMixin} from '@/components/transfers/mixins/TransferFormMixin.vue'
    import MapLocation from '~src/components/info/mapLocation.src'

    //TODO Need mixin with TransferAirportForm
    @Component({
        components: {MapLocation, TimeField, CityAutocomplete, DatePicker},
    })
    export class TransferManualForm extends mixins(TransferFormMixin) {
        @Prop() pointType
        @Prop() disabled
        @Prop() searchRequest
        @Prop() point
        @Prop({required: true}) transferInfo
        @VModel({default: true}) valid

        mapModal = false

        transferPoint = null

        async mounted() {
            this.initData()
        }

        initData() {
            this.transferPoint = this.transferInfo?.transferPoints?.find(
                t => t.pointType === this.pointType && t.type === 'MANUAL' && this.point.name === t.name
            )

            if (!this.transferPoint) {
                this.transferPoint = this.transferInfo?.transferPoints?.find(
                    t => t.pointType === this.pointType && t.type === 'MANUAL'
                )
            }

            this.setProp('type', 'manual')
            this.setProp('latitude', this.transferPoint?.latitude)
            this.setProp('longitude', this.transferPoint?.longitude)
            this.setProp('name', this.transferPoint?.name)
        }

        get basketItem() {
            return transfersStore.basketItem(this.$route.query.offerKey)
        }
    }

    export default TransferManualForm
</script>
